import { gql } from "@apollo/client";

export const CREATE_VENUE_MANAGER = gql`
  mutation createVenueManager($createVenueManagerInput: CreateVenueManagerInput!) {
    createVenueManager(createVenueManagerInput: $createVenueManagerInput) {
      id
    }
  }
`;
